import { DEFAULT_PHONE } from '../../../constants/contact-info';

export const SUPPORT_EMAIL_SUCCESS = 'Your message has been sent. A customer care expert will contact you shortly.';
export const SUPPORT_EMAIL_ERROR = `Sorry, there was an error sending your message. Please try again or call ${DEFAULT_PHONE} to speak with a customer care expert.`;
